import { CoordinatorService } from './coordinator.service';
import { License } from './license';

export type TIER = 'free' | 'basic' | 'premium';
export const tierLs: TIER[] = ['free', 'basic', 'premium'];

type CHECK_LICENSE_RESULT = {
    isPermitted: boolean;
    reason?: string;
    cloudProjectId?: string;
};

export class License$ {
    isReady = false;
    enforceLicense = false;

    licenseLs: License[] = [];
    b2cLicense!: License;
    b2bLicense: License | null = null;

    constructor(public coords: CoordinatorService) {}

    private _setScheduled({
        action,
        effective_at,
        resume_at,
    }: {
        action: string;
        effective_at: string;
        resume_at: string;
    }) {
        // if (action === 'cancel') {
        //     this.cancelDate = new Date(effective_at);
        // }
    }

    get currentTier(): TIER {
        if (this.b2bLicense && License.compare(this.b2bLicense, this.b2cLicense)) {
            return this.b2bLicense?.tier || 'free';
        }
        return this.b2cLicense.tier;
    }

    private async _checkFree(): Promise<CHECK_LICENSE_RESULT> {
        const resp = await this.coords.firebase$.callFunction('hasCloudProject', {});

        if (resp === 'ERROR')
            return {
                isPermitted: false,
                reason: 'quotaFreeExceeded',
            };

        const data = resp.data as any;

        // the free user is permitted a single cloud project,
        // if the response is true, the quota is exceeded

        if (data.hasCloudProject) {
            return {
                isPermitted: false,
                reason: 'quotaFreeExceeded',
                cloudProjectId: data.cloudProjectId,
            };
        }

        return {
            isPermitted: true,
        };
    }

    private async _checkBasic(): Promise<CHECK_LICENSE_RESULT> {
        const count = await this.countTeamProjects();
        const ownerCount = count.owner;
        const contributorCount: number = count.contributor;
        const teamCount = ownerCount + contributorCount;
        if (teamCount > 5)
            return {
                isPermitted: false,
                reason: 'teamCountExceeded',
            };
        return {
            isPermitted: true,
        };
    }

    async checkLicense(): Promise<CHECK_LICENSE_RESULT> {
        switch (this.currentTier) {
            case 'free':
                return await this._checkFree();
            case 'basic':
                return await this._checkBasic();
            default:
                return {
                    isPermitted: true,
                };
        }
    }

    async getLicenses() {
        this.licenseLs = [];
        this.b2bLicense = null;
        let b2cLicense: License | null = null;

        const resp = await this.coords.firebase$.callFunction('activeTierLs', {});

        // console.log('GET LICENSES resp', resp);
        if (!resp || resp === 'ERROR') return;
        const data = resp.data as any;

        data.tierLs?.forEach((x: any) => {
            console.log('TIER', x);
            this.licenseLs.push(new License(this.coords, x));

            // if (x.b2c) {
            //     this.subscriptionId = x.subscriptionId;
            // }

            // const t = x.tier as TIER;
            // const currentTierIndex = tierLs.indexOf(this.tier);
            // const newTierIndex = tierLs.indexOf(t);

            // if (newTierIndex > currentTierIndex) {
            //     this.tier = t;
            //     x.scheduled && this._setScheduled(x.scheduled);
            // }
        });

        for (const x of this.licenseLs) {
            console.log(8888, x);
            if (x.isB2B && (!this.b2bLicense || License.compare(x, this.b2bLicense))) {
                this.b2bLicense = x;
            } else if (x.isB2C && (!this.b2cLicense || License.compare(x, this.b2cLicense))) {
                b2cLicense = x;
            }
        }

        if (!b2cLicense) b2cLicense = new License(this.coords, { tier: 'free', b2c: true });
        this.b2cLicense = b2cLicense;

        this.isReady = true;
        this.coords.display$.markForCheck();
    }

    async refreshLicenses(isCloseLicenseManager = false) {
        await this.getLicenses();
        if (isCloseLicenseManager) this.coords.isLicenseManager = false;
        this.coords.display$.markForCheck();
    }

    async countTeamProjects() {
        const resp = await this.coords.firebase$.callFunction('countTeamProjects', {});
        if (resp === 'ERROR') return 0;
        return resp.data as any;
    }

    async checkTeamProjects() {
        const resp = await this.coords.firebase$.callFunction('checkTeamProjects', {});
        if (resp === 'ERROR') return false;

        return resp.data as any;
    }
}
